module.exports = __webpack_public_path__ + "static/media/20240319094946_IMG_6047-min.bed5b06d.JPG";